/**
 * Messenger Migration API Schemas
 */

import { z } from "zod";

export const MessengerMigrationRecordSchema = z.object({
  deploymentId: z.string(),
  deploymentName: z.string(),
  connectionId: z.string(),
  organizationId: z.string(),
  currentWebhookUrl: z.string(),
  expectedWebhookUrl: z.string(),
  webhookStatus: z.enum(["synced", "not_synced", "check_failed"]),
  error: z.string().nullable()
});

export const MessengerMigrationStatusResponseSchema = z.object({
  total: z.number(),
  webhookSynced: z.number(),
  webhookNotSynced: z.number(),
  webhookCheckFailed: z.number(),
  deployments: z.array(MessengerMigrationRecordSchema)
});

export const MigrateMessengerWebhookBodySchema = z.object({
  deploymentId: z.string().min(1)
});

export const MigrateMessengerWebhookResponseSchema = z.object({
  success: z.boolean(),
  deploymentId: z.string(),
  deploymentName: z.string(),
  webhookUrl: z.string().optional(),
  error: z.string().optional()
});
